/* eslint-disable react/jsx-pascal-case */
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../components/Loader';
import { fetchActions } from '../../Actions/actions';
import { selectActions } from '../../Actions/selectors';
import { fetchVehicle } from '../../Vehicles/actions';
import { selectVehicle } from '../../Vehicles/selectors';

import { selectUserId, selectWorks } from '../../Api/selectors';
import { REQUEST_VEHICLE } from '../../Vehicles/constants';
import { fetchUser } from '../../Users/actions';
import { REQUEST_USER } from '../../Users/constants';
import { HOOI_interior_inspection_mobile_page } from '../cells/HOOI/HOOI_interior_inspection_mobile_page';
import { Interior_inspection_mobile_page } from '../cells/Interior_inspection_mobile_page';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';

const Container = styled.div``;

/* eslint-disable react/prefer-stateless-function */
class MobileActionPageComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {
    this.props.fetchActions();
    this.props.fetchVehicle(this.props.match.params?.vehicleId);
    this.props.fetchUser(this.props.loggedInUserId);
  }

  get vehicle() {
    return this.props.vehicle;
  }

  get boardId() {
    return this.props.match.params?.board_id;
  }

  get documents() {
    return this.props.vehicle?.documents ?? [];
  }

  get entityId() {
    return this.vehicle?.id;
  }

  get entityType() {
    return 'vehicle';
  }

  getActionIdByName(name) {
    return this.props?.actions?.find(a => a.functionName === name)?.id ?? null;
  }

  render() {
    if (this.props.work) return <Loader small />;

    return (
      <Container>
        {this.props.genericInspection && env.clientId !== AppClientId.HOOIKAMMER ? (
          <Interior_inspection_mobile_page
            // cell={{ vehicle: this.vehicle }}
            loggedInUserId={this.props.loggedInUserId}
            vehicleId={this.props.vehicleId}
            board_id={this.boardId}
            action={{ label: 'label', id: this.getActionIdByName('WS2_1_Interior') }}
            payload={{ task_name: 'task_spray' }}
            column={{ label: 'WS2_7_ExteriorInspection' }}
          />
        ) : (
          <HOOI_interior_inspection_mobile_page
            // cell={{ vehicle: this.vehicle }}
            loggedInUserId={this.props.loggedInUserId}
            vehicleId={this.props.vehicleId}
            board_id={this.boardId}
            action={{ label: 'label', id: this.getActionIdByName('WS2_1_Interior') }}
            payload={{ task_name: 'task_spray' }}
            column={{ label: 'WS2_7_ExteriorInspection' }}
          />
        )}
      </Container>
    );
  }
}

MobileActionPageComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    actions: selectActions(),
    vehicle: selectVehicle(ownProps.vehicleId),
    // work: selectWorks([REQUEST_VEHICLE, REQUEST_USER]),
    work: selectWorks([REQUEST_USER]),
    loggedInUserId: selectUserId(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchActions() {
      dispatch(fetchActions());
    },
    fetchVehicle(vehicleId) {
      dispatch(fetchVehicle(vehicleId));
    },
    fetchUser(userId) {
      dispatch(fetchUser(userId));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const MobileActionPage = compose(withConnect, withRouter)(MobileActionPageComp);
